import { render, staticRenderFns } from "./BasicReq.vue?vue&type=template&id=69b7d1b8&scoped=true&"
import script from "./BasicReq.vue?vue&type=script&lang=js&"
export * from "./BasicReq.vue?vue&type=script&lang=js&"
import style0 from "./BasicReq.vue?vue&type=style&index=0&id=69b7d1b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b7d1b8",
  null
  
)

export default component.exports